/**
 * Entrance for PAG stat figures — used by both the standalone Stats Banner
 * section (.pag-stats-row) and the figures block inside the Trust Badges
 * panel (.pag-tb-stats).
 *
 * The figures are static. This script never touches their text: it used to
 * zero each number and count it back up on scroll, and Google's renderer
 * snapshots the page before that scroll ever happens, so rich-results tests
 * and indexing saw "0+ Products" and "0+ Yrs". Now it only adds a class when
 * a row scrolls into view, and CSS (assets/pag-overrides.css, "Stat figures")
 * plays a spring scale-up on each number. Whatever the timing, the text in
 * the DOM is always the real, server-rendered figure.
 */

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const STAGGER_MS = 110;

function onIntersect(entries) {
  for (const entry of entries) {
    if (!entry.isIntersecting) continue;

    // One-shot: once a row has played, it stays still on scroll back.
    observer.unobserve(entry.target);

    entry.target.querySelectorAll('.pag-stat').forEach((cell, index) => {
      cell.style.setProperty('--pag-stat-delay', `${index * STAGGER_MS}ms`);
      cell.classList.add('pag-stat--pop');
    });
  }
}

/**
 * The row is also revealed by assets/pag-reveal.js, which holds each .pag-stat
 * at opacity 0 until its tween runs at 'top 78%'. The bottom rootMargin lines
 * the pop up with that reveal instead of playing it while still invisible.
 */
const observer = new IntersectionObserver(onIntersect, {
  threshold: 0.25,
  rootMargin: '0px 0px -18% 0px',
});

function scan(root) {
  for (const row of root.querySelectorAll('.pag-stats-row, .pag-tb-stats')) observer.observe(row);
}

if (!reducedMotion.matches) {
  scan(document);

  // The theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
}
